<template>
  <section>
    <el-col
      v-if="buttonList != null && buttonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.AttendeeName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.CompanyName"
            placeholder="公司名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.ParticipantTypeId">
            <el-option
              label="--请选择参会类型--"
              :value="0"
              :key="0"
            ></el-option>
            <el-option
              v-for="item in participantTypes"
              :label="item.Name"
              :value="item.Id"
              :key="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="filters.ActivityId"
            placeholder="请输入活动名称"
            :loading="loadingActivityName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
          >
            <el-option
              v-for="item in activityList"
              :key="item.ActivityId"
              :label="item.ActivityName"
              :value="item.ActivityId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in buttonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tableList"
      border=""
      v-loading="listLoading"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column
        prop="CompanyName"
        label="参会人公司名称"
        width="230"
      ></el-table-column>
      <el-table-column
        prop="AttendeeName"
        label="参会人姓名"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号码"
        width="120"
      ></el-table-column>
      <el-table-column prop="Email" label="邮箱" width="120"></el-table-column>
      <el-table-column
        prop="DeptPostion"
        label="职位"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="CreateTime"
        label="录入时间"
        width="170"
      ></el-table-column>
      <el-table-column
        prop="ParticipantTypeName"
        label="参会类别"
        width="100"
      ></el-table-column>
      <el-table-column prop="" label="是否含餐" width="100"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IsIncludeMeal">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="" label="是否同步" width="100"
        ><template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.IsSync">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template></el-table-column
      >
      <el-table-column prop="" label="状态" width="100">
        <template slot-scope="scope">
          <el-switch
            @change="enabledChange(scope)"
            v-model="scope.row.IsEnabled"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="Source" label="来源" width="100"></el-table-column>
      <el-table-column
        prop="ActivityName"
        label="活动名称"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>
    <!-- 新增客户用户 -->
    <el-dialog
      title="参会人员信息录入"
      :visible.sync="addFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
      >
        <el-form-item prop="ActivityName" label="当前活动">
          <el-input disabled v-model="ruleForm.ActivityName"></el-input>
        </el-form-item>
        <el-form-item prop="ParticipantTypeId" label="可录入参会类别">
          <el-select
            v-model="ruleForm.ParticipantTypeId"
            @change="participantTypeSelectChange"
          >
            <el-option
              label="--请选择参会类型--"
              :value="0"
              :key="0"
            ></el-option>
            <el-option
              v-for="item in participantTypes"
              :label="item.Name"
              :value="item.Id"
              :key="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="CompanyName" label="公司名称">
          <el-input
            placeholder="公司名称"
            v-model="ruleForm.CompanyName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="AttendeeName" label="参会人姓名">
          <el-input
            placeholder="参会人姓名"
            v-model="ruleForm.AttendeeName"
            clearable
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item prop="DeptPostion" label="部门职位">
          <el-input
            placeholder="部门职位"
            v-model="ruleForm.DeptPostion"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item prop="PhoneNumber" label="手机号码">
          <el-input
            placeholder="手机号码"
            v-model="ruleForm.PhoneNumber"
            clearable
            maxlength="11"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item prop="Email" label="邮箱">
          <el-input
            placeholder="邮箱"
            v-model="ruleForm.Email"
            clearable
            max="5"
          ></el-input>
        </el-form-item>
        <el-form-item prop="IsIncludeMeal" label="是否含餐">
          <el-select
            v-model="ruleForm.IsIncludeMeal"
            placeholder="请选择是否含餐"
          >
            <el-option label="不含餐" :value="false"></el-option>
            <el-option label="含餐" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addOrUpd('ruleForm')"
            >提 交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisible1"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="importTop">
        <div><span>1</span>上传文件</div>
        <div><span>2</span>导入数据</div>
      </div>
      <div class="importList">
        <div class="bgIcon"></div>
        <div class="importList_R">
          <p class="font6">填写导入数据信息</p>
          <p class="font9">
            请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除
          </p>
          <p>
            <a href="#" @click="downloadTemp" class="fontG">下载模板</a>
          </p>
        </div>
      </div>
      <div class="importList">
        <div class="bgIcon bgIcon1"></div>
        <div class="importList_R">
          <p class="font6">上传</p>
          <p class="font9">
            文件后缀名必须为xls 或xlsx
            （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据
          </p>
          <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :http-request="uploadAtteedee"
            :on-progress="importProgress"
            :before-upload="importBefore"
            :show-file-list="false"
            :file-list="fileList"
            :on-change="fileChange"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          >
            <p>
              <a href="#" class="fontG">{{ importText }}</a>
            </p>
          </el-upload>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" @click="dialogVisible1 = false">
        <el-button @click="dialogVisible1 = false" class="hoverBtn1"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisibleFailure"
      :before-close="importFailureHandleClose"
      width="50%"
    >
      <div class="importTop">
        <div><span>1</span>上传文件</div>
        <div><span>2</span>导入数据</div>
      </div>
      <div class="importList">
        <div class="bgIcon3"><i class="el-icon-warning"></i></div>
        <div class="importList_R">
          <p class="font6">
            正常数量条数: <span class="fontG">{{ successCount }}条</span>
          </p>
          <p class="font6">
            异常数量条数: <span class="fontR">{{ errorCount }}条</span>
          </p>
        </div>
      </div>
      <div class="abnormalBox">
        <p class="title">异常提示：</p>
        <p v-for="item in errorMsg" :key="item">{{ item }}</p>
        <p>请检查无误后重新上传！</p>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
        @click="dialogVisibleFailure = false"
      >
        <el-button @click="importAgain" type="primary" class="fontF"
          >重新上传</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="批量导入"
      class="dialog-import"
      :visible.sync="dialogVisibleSuccess"
      :before-close="importSuccessHandleClose"
      width="50%"
    >
      <div class="SuccessBox">
        <i class="el-icon-success"></i>
        <h4 class="font6">批量导入完成</h4>
        <p class="font9">{{ improtMsg }}</p>
      </div>
    </el-dialog>
    <el-dialog
      title="批量导入中"
      class="dialog-import"
      :visible.sync="dialogVisibleLoading"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="SuccessBox">
        <i class="el-icon-loading"></i>
        <h4 class="font6">数据导入中，请耐心等待....</h4>
      </div>
    </el-dialog>
    <el-dialog
      title="批量导出"
      class="dialog-import"
      :visible.sync="dialogExport"
      :before-close="importHandleClose"
      width="50%"
    >
      <div class="SuccessBox1">
        <a :href="exportLink" target="_blank"
          ><i class="el-icon-upload position_relative"></i>下载导出文件</a
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="syncInfo.Title"
      :visible.sync="syncFormVisible"
      width="50%"
      :close-on-click-modal="false"
      :before-close="handleSyncClose"
    >
      <p v-for="(item, i) in syncInfo.Msgs" :key="i">{{ item }}</p>
    </el-dialog>
  </section>
</template>

<script>
const token = window.localStorage.getItem('Token')
// import util from "../../../util/date";
import { getButtonList } from '../../promissionRouter'
import {
  getParticipantTypeList,
  getActivityList,
  getAttendeeList,
  addOrUpdAttendee,
  getAttendeeById,
  importAttendeeFile,
  syncAttendee,
  enabledAttendee,
} from '../../api/api'

export default {
  data() {
    return {
      syncInfo: {
        Msgs: [],
        Title: '',
      },
      syncFormVisible: false,
      fileList: [],
      isEdit: false,
      listLoading: false,
      uploadUrl: '',
      loadingActivityName: false, // 适用活动 加载效果
      filters: {
        ParticipantTypeId: 0,
        CompanyName: '',
        PhoneNumber: '',
        ActivityId: '',
        page: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      activityList: [],
      participantTypes: [],
      buttonList: [],
      tableList: [],
      addFormVisible: false, // 新增弹框
      importText: '上传文件',
      importDisabled: false,
      improtMsg: '',
      successCount: 0,
      errorCount: 0,
      errorMsg: {},
      dialogVisible1: false,
      dialogVisibleLoading: false,
      dialogVisibleSuccess: false,
      dialogVisibleFailure: false,
      dialogExport: false,
      exportLink: `${process.env.VUE_APP_BASE_API}/api/attendee/template/export`,
      headers: { Authorization: 'Bearer ' + token },
      // 新增弹窗数据
      ruleForm: {
        Id: 0,
        ActivityId: '',
        ActivityName: '',
        ParticipantTypeId: 0,
        ParticipantTypeName: '',
        CompanyName: '',
        AttendeeName: '',
        DeptPostion: '',
        PhoneNumber: '',
        Email: '',
        IsIncludeMeal: false,
      },
      rules: {
        ParticipantTypeId: [
          {
            type: 'number',
            min: 1,
            message: '请选择参会类别',
            trigger: 'blur',
          },
        ],
        CompanyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '公司名称长度在1到50个字符',
            trigger: 'blur',
          },
        ],
        AttendeeName: [
          { required: true, message: '请输入参会人姓名', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '参会人姓名长度在1到50个字符',
            trigger: 'blur',
          },
        ],
        DeptPostion: [
          { required: true, message: '请输入部门职位', trigger: 'blur' },
          {
            min: 1,
            max: 50,
            message: '部门职位长度在1到50个字符',
            trigger: 'blur',
          },
        ],
        PhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1\d{10}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],
        Email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'blur'],
          },
        ],
        IsIncludeMeal: [
          { required: true, message: '请选择是否含餐', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item) {
      console.log(item)
      this[item.Func].apply(this)
    },
    dialogCheck(selection, row) {
      this.currentRow = null
      this.$refs.table.clearSelection()
      if (selection.length === 0) {
        return
      }
      if (row) {
        this.selectCurrentRow(row)
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val
        this.$refs.table.clearSelection()
        this.$refs.table.toggleRowSelection(val, true)
      }
    },
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.page = currentPage
      this.handleQuery()
    },

    // 新增客户用户
    handleAdd() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择活动',
          type: 'error',
        })
      } else {
        this.ruleForm.Id = 0
        const activityId = this.filters.ActivityId
        this.ruleForm.ActivityId = activityId
        this.ruleForm.ActivityName = this.activityList.find(
          (ele) => ele.ActivityId === activityId
        ).ActivityName
        this.isEdit = false
        this.addFormVisible = true
      }
    },
    handleSync() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择活动！',
          type: 'error',
        })
      } else {
        console.log(this.filters.ActivityId)
        syncAttendee(this.filters.ActivityId).then((res) => {
          console.log(res)
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: 'success',
            })
            this.handleQuery()
          } else {
            this.syncInfo = res.data.response
            this.syncFormVisible = true
          }
        })
      }
    },
    handleSyncClose(formName) {
      this.syncFormVisible = false
      this.syncInfo = {}
    },
    addOrUpd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addOrUpdAttendee(this.ruleForm).then((res) => {
            if (res.data.success) {
              this.handleQuery()
              this.$message({
                message: res.data.msg,
                type: 'success',
              })
              this.addFormVisible = false
            } else {
              this.$message({
                message: res.data.msg,
                type: 'error',
              })
            }
          })
        } else {
          return false
        }
      })
    },
    handleQuery() {
      this.listLoading = true
      getAttendeeList(this.filters).then((res) => {
        console.log(res)
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tableList = res.data.response.data

          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
    // 编辑
    handleUpdate() {
      let row = this.currentRow
      console.log(row)
      this.options = []
      if (!row) {
        this.$message({
          message: '请选择要下载的一行数据！',
          type: 'error',
        })
        return
      }

      getAttendeeById(row.Id).then((res) => {
        if (res.data.success) {
          this.ruleForm = res.data.response
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })

      this.isEdit = true
      this.addFormVisible = true
    },
    // 适用的活动
    remoteMethod(query) {
      if (query !== '') {
        this.loadingActivityName = true

        setTimeout(() => {
          this.loadingActivityName = false

          getActivityList(query).then((res) => {
            this.activityList = res.data.response
          })
        }, 500)
      }
    },
    participantTypeSelectChange(val) {
      console.log(val)
      this.ruleForm.ParticipantTypeName = this.participantTypes.find(
        (ele) => ele.Id == val
      ).Name
    },
    handleClose(formName) {
      this.addFormVisible = false
      this.$refs.ruleForm.resetFields()
    },
    importHandleClose() {
      this.dialogVisible1 = false
    },
    importSuccessHandleClose() {
      this.dialogVisibleSuccess = false
    },
    importFailureHandleClose() {
      this.dialogVisibleFailure = false
    },
    uploadAtteedee(param) {
      const form = new FormData()
      form.append('file', param.file)
      importAttendeeFile({
        activityId: this.filters.ActivityId,
        form,
      })
        .then((response) => {
          console.log('uploadAtteedee success response')
          console.log(response)
          param.onSuccess() // 上传成功的图片会显示绿色的对勾
          this.dialogVisibleLoading = false
          this.successCount = response.data.response.SuccessCount
          this.errorCount = response.data.response.ErrorCount
          if (response.data.success) {
            if (!response.data.response.Result) {
              this.dialogVisibleFailure = true
              this.errorMsg = response.data.response.ErrorMsg.split(';')
              return
            } else {
              this.dialogVisibleSuccess = true
              this.improtMsg = '导入成功'
              this.handleQuery()
            }
          } else {
            this.errorMsg = response.data.response.ErrorMsg.split(';')
            this.dialogVisibleFailure = true
          }
        })
        .catch((response) => {
          console.log('uploadAtteedee fail response')
          console.log(response)
          param.onError()
          this.dialogVisibleLoading = false
          this.$message.error('导入异常，请联系开发人员')
        })
    },
    fileChange(file) {
      this.$refs.upload.clearFiles() //清除文件对象
      this.fileList = [{ name: file.name, url: file.url }] // 重新手动赋值filstList， 免得自定义上传成功了, 而fileList并没有动态改变， 这样每次都是上传一个对象
    },
    handleImport() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择活动',
          type: 'error',
        })
      } else {
        this.dialogVisible1 = true
      }
    },
    handleExport() {
      if (!this.filters.ActivityId) {
        this.$message({
          message: '请先选择活动',
          type: 'error',
        })
      } else {
        const token = window.localStorage.getItem('Token')
        const url = `${process.env.VUE_APP_BASE_API}/api/Attendee/export`
        var xhr = new XMLHttpRequest()
        xhr.open('post', url, true)
        // 2.2 设置请求头,作用是设置参数的编码格式，以便后台能够正确的接收所传递的参数
        xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
        xhr.responseType = 'blob' // 返回类型blob
        xhr.setRequestHeader('Authorization', 'Bearer ' + token) // 携带token校验

        xhr.onload = function () {
          if (this.status === 200) {
            var blob = this.response
            var reader = new FileReader()
            reader.readAsDataURL(blob) // 转换为base64
            reader.onload = function (e) {
              var a = document.createElement('a') // 创建一个a标签用于下载
              a.download = '参会人员.xls' //文件名
              a.href = e.target.result
              a.click()
              $(a).remove()
            }
          }
        }
        xhr.send(JSON.stringify(this.filters))
      }
    },
    downloadTemp() {
      window.open(this.exportLink)
    },
    importProgress(event, file, fileList) {
      this.dialogVisibleLoading = true
      console.log(event, file, fileList)
    },
    importBefore(file) {
      if (
        file.type !== 'application/vnd.ms-excel' &&
        file.type !==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        this.$message.error('请上传xls或xlsx格式的Excel')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('上传的文件不得大于10M')
        return false
      }
    },
    importAgain() {
      this.dialogVisible1 = true
      this.importDisabled = false
      this.importText = '上传文件'
    },
    reImport(id) {
      var _this = this
      this.$confirm('是否重新导入?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          _this.del(id)
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    enabledChange(scope) {
      enabledAttendee({
        Id: scope.row.Id,
        IsEnabled: scope.row.IsEnabled,
      }).then((res) => {
        console.log(res)
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: 'success',
          })
          this.handleQuery()
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)
    this.handleQuery()

    getParticipantTypeList().then((res) => {
      console.log(res)
      this.participantTypes = res.data.response.filter((item) => {
        return item.Name != '领奖嘉宾'
      })
    })
  },
}
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.dialog-import .importTop {
  display: flex;
  font-weight: bold;
  color: #666;
}

.dialog-import .importTop > div {
  margin-right: 30px;
}

.dialog-import .importTop > div span {
  display: inline-block;
  width: 40px;
  height: 40px;
  font-size: 30px;
  line-height: 40px;
  color: #fff;
  background: #30a53f;
  margin-right: 10px;
  text-align: center;
}

.dialog-import .importTop > div:last-child span {
  background: #cccccc;
}

.dialog-import .importList {
  display: flex;
  border: 1px solid #e9e9e9;
  align-items: center;
  height: 110px;
  margin-top: 20px;
}

.dialog-import .importList .bgIcon {
  background: url(../../assets/icon_download.png) no-repeat center #f5f5f5;
  height: 100%;
  width: 100px;
  line-height: 110px;
  background-size: 60px;
  margin-right: 15px;
  text-align: center;
}

.dialog-import .importList .bgIcon1 {
  background: url(../../assets/icon_upload.png) no-repeat center #f5f5f5;
  background-size: 60px;
}

.dialog-import .importList .bgIcon3 {
  background: #f5f5f5;
  font-size: 46px;
  color: #cccccc;
  width: 100px;
  margin-right: 15px;
  text-align: center;
  height: 100%;
  line-height: 110px;
}

.dialog-import .importList .importList_R {
  font-size: 14px;
  flex: 1;
}

.dialog-import .importList .importList_R > p {
  padding: 5px 0;
  margin: 0 0;
}
.upload-demo p {
  padding: 0 0;
  margin: 0 0;
}
.fontG {
  color: #30a53f;
}
.SuccessBox {
  text-align: center;
  margin: 30px 0;
}

.SuccessBox i {
  color: #30a53f;
  font-size: 100px;
}

.SuccessBox h4 {
  margin: 30px;
  font-size: 20px;
}

.SuccessBox1 {
  margin: 50px auto;
  width: 20%;
  padding: 0 20px;
  line-height: 50px;
  height: 50px;
  text-align: center;
  background: #30a53f;
}

.SuccessBox1 i {
  font-size: 30px;
  color: #fff;
  top: 5px;
  margin-right: 10px;
}

.SuccessBox1 a {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
}

.position_relative {
  position: relative;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #30a53f !important;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>
